import { render, staticRenderFns } from "./SpinnerFlexible.vue?vue&type=template&id=0b5abe39&scoped=true"
var script = {}
import style0 from "./SpinnerFlexible.vue?vue&type=style&index=0&id=0b5abe39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5abe39",
  null
  
)

export default component.exports